/**
 * Nederlandse teksten van de kop en de tabbladen van één keuring. Jij-vorm; de
 * woorden volgen `docs/woordenlijst.md` (§ Schermen en navigatie).
 */
export const orderLayoutCopy = {
    back: 'Keuringen',
    backLabel: 'Terug naar Keuringen',

    eyebrow: (number: string, services: string) => `keuring ${number} · ${services}`,
    loading: 'Keuring',

    status: 'Status',
    client: 'Klant',
    moment: 'Opname',
    notPlanned: 'nog niet ingepland',
    inspector: 'Inspecteur',
    /* Zoals in de lijst Keuringen. */
    noInspector: 'niet toegewezen',
    /** Een dienst zonder vragenlijst die nog niet klaar is gemeld, zoals het energielabel. */
    openServices: 'Nog open',

    tabsLabel: 'Keuring',
    tabs: {
        overview: 'Overzicht',
        survey: 'Opname',
        /** Heeft de keuring meer dan één opname, dan zegt het tabblad van welke dienst. */
        surveyFor: (service: string) => `Opname ${service}`,
        energyLabel: 'Energielabel',
        report: 'Rapport',
        clientPage: 'Klantpagina',
    },
} as const;
